// extracted by mini-css-extract-plugin
module.exports = {"courseCardPrice":"CourseCardPrice__courseCardPrice__DxuZ0","oldPrice":"CourseCardPrice__oldPrice__3vFYn"};